<template>
  <div class="medicalBox">
    <div class="goBackBox" @click="closeWebs">
      <img src="../../assets/images/medicalGoBack.png" alt="" />
      <h2>{{ detailsList.title }}</h2>
    </div>
    <div class="titleBox" v-if="detailsList.type != 12">
      <div
        class="videoBox"
        v-if="detailsList.type == 11 && detailsList.videoUrl"
        ontouchmove="return false;"
      >
        <video
          ref="video"
          width="100%"
          height="224px"
          controls
          muted
          loop
          autoplay
          preload="auto"
          playsinline
        >
          <!-- @fullscreenchange="handleFullScreenChange"
          @webkitfullscreenchange="handleFullScreenChange"
          :style="videoStyle" -->
          <source :src="imgUrl + detailsList.videoUrl" type="video/mp4" />
          <button @click="toggleFullScreen">Toggle Full Screen</button>
        </video>
      </div>
      <h3>{{ detailsList.introduction }}</h3>
      <h6 v-if="detailsList.type == 2 && detailsList.rxName">
        处方：{{ detailsList.rxName }}
      </h6>
      <h6 v-if="detailsList.type == 2 && detailsList.insured">
        医保：{{ detailsList.insured }}
      </h6>
      <h6 v-if="(detailsList.type == 4 || detailsList.type == 5) && detailsList.otherName">
        其他名称：{{ detailsList.insured }}
      </h6>
      <h6 v-if="detailsList.type == 4 || detailsList.type == 5">
        <p
          v-if="
            detailsList.repoCategories &&
            detailsList.repoCategories.some(
              (item) => item.repoType === 7 && item.label
            )
          "
        >
          发病部位：
          <template v-for="(item, index) in detailsList.repoCategories">
            <p v-if="item.repoType === 7" :key="index">
              {{ item.label }}&nbsp;&nbsp;
            </p>
          </template>
        </p>
      </h6>
      <h6 v-if="detailsList.type == 4 || detailsList.type == 5">
        <p
          v-if="
            detailsList.repoCategories &&
            detailsList.repoCategories.some(
              (item) => item.repoType === 8 && item.label
            )
          "
        >
          就诊科室：
          <template v-for="(item, index) in detailsList.repoCategories">
            <p v-if="item.repoType === 8" :key="index">
              {{ item.label }}&nbsp;&nbsp;
            </p>
          </template>
        </p>
      </h6>
    </div>
    <ul class="detailsBox">
      <li v-for="(item, index) in detailsList.repoDetails" :key="index">
        <h2>{{ item.repoTitle }}</h2>
        <p>{{ item.content }}</p>
      </li>
    </ul>
    <div id="ceshi"></div>
  </div>
</template>

<script>
import { byIdSyKb } from "@/api/medical/index.js";
import { getToken, setToken } from "@/utils/auth";
export default {
  data() {
    return {
      detailsList: {},
      flagId: undefined,
      // flagId: "1818547657531932673",
      imgUrl: "https://file.medmeta.com/",
      currentHostType: null,
    };
  },
  created() {
    // let token =
    //   "eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoxNywidXNlcl9pZCI6MTI4LCJvcmdfaWQiOjAsInVzZXJfa2V5IjoiNmVmZThhNzktMGYyYS00Njc5LWI2ZWMtMWZmYzg3ZmY2YWMyIiwiZGV2aWNlX3R5cGUiOiJBZG1pbiIsInVzZXJuYW1lIjoiMTMxMjM0NTY3ODkifQ.2wAE2Gto8Azc_EcIXzmTStvoSJtyRWBBd4l2TZPQkOMVuyhPrT54xvlynEMvxVzQlC26yxLlGAYn8ay8DR6McQ";
    // this.getByIdSyKb(token);
    this.androidIos();
  },
  mounted() {
    window.getU3dParams = this.getU3dParams;
  },
  methods: {
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      console.log("是否是Android：" + isAndroid); //true,false
      console.log("是否是iOS：" + isIOS);
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },
    androidIos() {
      if (this.judgeClient() == "Android") {
        this.callAndroidFunctionWithParameter();
      } else {
        // window.getU3dParams = this.getU3dParams;
        this.getAppParams();
      }
    },
    callAndroidFunctionWithParameter() {
      // let data = {
      //   rounter: 109 /* int 类型枚举变量 */,
      //   callBack: true /* bool 类型，告诉客户端是否需要回调 */,
      //   params: {},
      // };
      const that = this;
      this.$bridge.callmethod(
        "WebAction.getAppParams",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
      this.$bridge.registermethod("getU3dParams", (data) => {
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        setToken(token);
        this.flagId = jsonData.flagId;
        this.currentHostType = jsonData.currentHostType;
        if (this.currentHostType == 100) {
          this.imgUrl = "http://192.168.3.113/file/";
        } else if (this.currentHostType == 101) {
          this.imgUrl = "https://192.168.3.123/file/";
        } else if (this.currentHostType == 102) {
          this.imgUrl = "https://192.168.3.126/file/";
        } else if (this.currentHostType == 103) {
          this.imgUrl = "https://192.168.3.192/file/";
        } else {
          this.imgUrl = "https://file.medmeta.com/";
        }
        // this.$nextTick(() => {
        this.$nextTick(() => {
          this.getByIdSyKb(token);
          // })
        });
      });
    },
    getAppParams() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.getAppParams.postMessage(
          "js调用ios",
          (data) => {}
        );
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    getU3dParams(data) {
      const jsonData = JSON.parse(data);
      const token = jsonData.token;
      setToken(token);
      this.flagId = jsonData.flagId;
      this.currentHostType = jsonData.currentHostType;
      if (this.currentHostType == 100) {
        this.imgUrl = "http://192.168.3.113/file/";
      } else if (this.currentHostType == 101) {
        this.imgUrl = "https://192.168.3.123/file/";
      } else if (this.currentHostType == 102) {
        this.imgUrl = "https://192.168.3.126/file/";
      } else if (this.currentHostType == 103) {
        this.imgUrl = "https://192.168.3.192/file/";
      } else {
        this.imgUrl = "https://file.medmeta.com/";
      }
      // document.getElementById("ceshi").innerHTML = this.flagId;
      this.$nextTick(() => {
        this.getByIdSyKb(token);
      });
    },
    closeWebs() {
      if (this.judgeClient() == "Android") {
        this.closeAndroid();
      } else {
        this.closeIos();
      }
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    async getByIdSyKb(token) {
      const { data } = await byIdSyKb(this.flagId, token);
      // document.getElementById("ceshi").innerHTML = this.ids;
      this.detailsList = data;
      console.log("this.detailsList", this.detailsList);
    },
  },
};
</script>

<style lang="scss" scoped>
.medicalBox {
  // position: relative;
  padding: 0 15px 0 16px;
  .goBackBox {
    position: fixed;
    top: 0px;
    left: 15px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    background-color: #ffffff;
    img {
      width: 24px;
      height: 24px;
    }
    h2 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }
  .titleBox {
    // display: flex;
    // flex-direction: column;
    // align-items: center
    margin-top: 44px;
    padding-top: 11px;
    padding-bottom: 6px;
    width: 100%;
    // height: 70px;
    border-bottom: 1px solid #f8f8f8;

    .videoBox {
      width: 100%;
      // height: 224px;/
      video {
        width: 100%; /* 让视频宽度充满父元素 */
        height: 100%; /* 让视频高度充满父元素 */
        object-fit: fill;
      }
    }

    h3 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
    h6 {
      // display: inline-block;
      // margin-top: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #999999;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      p {
        display: inline-block;
      }
    }
  }
  .detailsBox {
    margin-top: 11px;
    li {
      margin-bottom: 6px;
      list-style: none;
      h2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 15px;
        color: #333333;
        line-height: 26px;
        letter-spacing: 1px;
        text-align: left;
        font-style: normal;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        line-height: 24px;
        letter-spacing: 1px;
        text-align: left;
        font-style: normal;
        white-space: pre-line;
      }
    }
  }
}
</style>